
import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import CustomSolutionsDialog from './CustomSolutionsDialog';

const CustomSolutionsHero = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  return (
    <section className="relative py-32 overflow-hidden bg-gradient-to-br from-[#1A1F2C] to-[#2C2A3A] text-white">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="/lovable-uploads/Custom-Solutions-2.jpg"
          alt="Custom AI Solutions"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A1F2C]/85 to-[#2C2A3A]/85"></div>
      </div>
      
      <div className="container mx-auto relative z-10 px-6 flex flex-col items-center">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight text-white text-center">
            Custom AI Solutions Built for Now — <span className="text-gradient">and What's Next</span>
          </h1>
          
          <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed text-center">
            Custom AI automation isn't rocket science. It's smart business — and it's happening right now. 
            Forward-thinking firms are already streamlining client work, reducing overhead, and positioning 
            themselves to win. With DocketLabs, building tailored, powerful AI solutions is simpler, 
            faster, and more affordable than you think — helping your firm move today, and lead tomorrow.
          </p>
          
          <Button 
            size="lg" 
            className="bg-primary text-white hover:bg-primary/90 rounded-lg px-8 py-6 text-lg shadow-lg shadow-primary/20 relative overflow-hidden group"
            onClick={() => setIsDialogOpen(true)}
          >
            <span className="relative z-10 flex items-center">
              Book a Free Custom Solutions Call
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </span>
            <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-blue-600 to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity"></span>
          </Button>
          
          <p className="mt-6 text-gray-300 italic text-center">
            Bring your ideas. We'll bring the possibilities.
          </p>
        </div>
      </div>

      {/* Custom Solutions Dialog */}
      <CustomSolutionsDialog 
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />
    </section>
  );
};

export default CustomSolutionsHero;
